module.exports = __webpack_public_path__ + "img/73ne.45a090ee.svg";